import {logEvent } from "firebase/analytics";
import { Phone, Instagram, BookOpen, MapPin } from 'lucide-react';
import { analytics } from "../firebase"; // firebase.jsのインポート
import { useHistory } from 'react-router-dom';


const isMobile = window.innerWidth <= 799;


export const BottomTab = () => {
  const history = useHistory();

  const handlePhoneCall = () => {
    window.location.href = 'tel:07042870007';
    logEvent(analytics, 'tap_call', { custom_param: 'tap call triggered' });
  };

  const handleInstagramOpen = () => {
    window.open('https://www.instagram.com/sealine_3/', '_blank');
    logEvent(analytics, 'tap_insta', { custom_param: 'tap insta triggered' });

  };
  const handleAmebloOpen = () => {
    history.push(`/BlogList`);
    logEvent(analytics, 'tap_blog', { custom_param: 'tap blog triggered' });

  };
  const handleMapOpen = () => {
    window.open('https://maps.app.goo.gl/gTU8GHXFU684zHZK6', '_blank');
    logEvent(analytics, 'tap_map', { custom_param: 'tap map triggered' });

  };

  return (
    <>
      {isMobile && (
        <div className="menu-button2">
          <button className="buttom-call" onClick={handlePhoneCall}>
            <Phone size={24} />
            <br />
            <span>Phone</span>
          </button>
          <button className="buttom-insta" onClick={handleInstagramOpen}>
            <Instagram size={24} />
            <br />
            <span>Instagram</span>
          </button>
          <button className="buttom-ameblo" onClick={handleAmebloOpen}>
            <BookOpen size={24} />
            <br />
            <span>ブログ</span>
          </button>
          <button className="buttom-map" onClick={handleMapOpen}>
            <MapPin size={24} />
            <br />
            <span>住所</span>
          </button>
        </div>
      )}
    </>
  );
};
